import './Skeleton.css';

import { cn } from '../../utils/bem';

export { SkeletonBrick } from './SkeletonBrick/SkeletonBrick';
export { SkeletonCircle } from './SkeletonCircle/SkeletonCircle';
export { SkeletonText } from './SkeletonText/SkeletonText';

export const cnSkeleton = cn('Skeleton');
